import { Home, FileText, Users, UserCheck, Shield, LogOut, FileSpreadsheet, Plus, Eye, UserPlus, Settings, MapPin, Receipt, Trash2, UserCog, Map, Timer, Building2 } from "lucide-react";
import { Link, useLocation } from "react-router-dom";


// const { reportTempId } = () => useParams();
// const effect

export const navItems = [
  {
    icon: <FileText size={20} />,
    imgUrl: null,
    title: "reporting",
    path: "/reporting",
  },
  {
    icon: <Users size={20} />,
    imgUrl: null,
    title: "User List",
    path: "/userlist",
  },
  {
    icon: <Building2 size={20} />,
    imgUrl: null,
    title: "Client List",
    path: "/clientlist",
  },
  {
    icon: <LogOut size={20} />,
    imgUrl: null,
    title: "Sign out",
    path: "/",
  },
];

export const reporting = [
  {
    icon: <Plus size={16} />,
    title: "create report",
    path: `/createreport`,
  },
  {
    icon: <Eye size={16} />,
    title: "view report",
    path: "/viewreport",
  },
  {
    icon: <UserPlus size={16} />,
    title: "assign report",
    path: "/assignreport",
  },
  {
    icon: <Map size={16} />,
    title: "Create Tour",
    path: "/createtour",
  },
  {
    icon: <Eye size={16} />,
    title: "View Tour",
    path: "/viewtour",
  },
];

export const inVoicing = [
  {
    icon: <UserPlus size={16} />,
    title: "set up new client",
    path: "/setupnewclient",
  },
  {
    icon: <Settings size={16} />,
    title: "modify client",
    path: "/modifyclient",
  },
  {
    icon: <FileSpreadsheet size={16} />,
    title: "generate invoice",
    path: "/generateinvoice",
  },
  {
    icon: <Eye size={16} />,
    title: "view open invoices",
    path: "/viewopeninvoices",
  },
  {
    icon: <Eye size={16} />,
    title: "view paid invoices",
    path: "/viewpaidinvoices",
  },
  {
    icon: <Receipt size={16} />,
    title: "invoice statement",
    path: "/invoicestatement",
  },
  {
    icon: <Trash2 size={16} />,
    title: "delete invoice",
    path: "/deleteInvoice",
  },
];

export const scheduleGuardManagement = [
  {
    icon: <UserCog size={16} />,
    title: "assign permissions",
    path: "/assignpermissions",
  },
  {
    icon: <MapPin size={16} />,
    title: "geolocation set up",
    path: "/geolocationsetup",
  },
  {
    icon: <Timer size={16} />,
    title: "time clock set up",
    path: "/timeclocksetup",
  },
];

export const userList = [
  {
    icon: <Building2 size={16} />,
    title: "Client ",
    path: "/userclient",
  },
  {
    icon: <Shield size={16} />,
    title: "Security ",
    path: "/security",
  },
  {
    icon: <UserCheck size={16} />,
    title: "Management",
    path: "/managements",
  },
  {
    icon: <Settings size={16} />,
    title: "administrator",
    path: "/adminlist",
  },
];

// Client Nav Items

export const clientNav = [
  {
    icon: <Home size={16} />,
    title: "Home",
    path: "/clienthome",
  },
  {
    icon: <FileText size={16} />,
    title: "Reporting",
    path: "/clientreport",
  },
];
export const managementNav = [
  {
    icon: <Home size={16} />,
    title: "Home",
    path: "/managementhome",
  },
  {
    icon: <FileText size={16} />,
    title: "Reporting",
    path: "/managementreport",
  },
];

export const ReportingMap = ({
  reporting,
  activeSideNav,
  showSideNav,
  location,
  // handleSideNavClick,
}) => (
  <div>
    {reporting &&
      reporting.map((item, index) => {
        const isActive = location?.pathname.includes(item?.path);

        return (
          <Link
            key={index}
            to={item.path}
            // onClick={() => handleSideNavClick(item.path)}
          >
            <div
              className={`${
                showSideNav && " "
              } flex gap-3 cursor-pointer py-1.5 rounded-md transition-colors duration-150 ease-in-out pl-5 ml-3 ${
                isActive ? activeSideNav : " hover:bg-[#00325d] hover:text-white"
              }${index !== 0 ? " mt-1" : ""}`}
            >
              {/* <span
                className={`transition-transform text-[14px] leading-[20px]`}
              >
                {item.icon}
              </span> */}
              <span className='text-[14px] leading-[20px] font-normal text-nowrap'>{item.title}</span>
            </div>
          </Link>
        );
      })}
  </div>
);

export const MapScheduleGuardManagement = ({
  activeSideNav,
  showSideNav,
  activeIcons,
  setActiveIcons,
  // handleSideNavClick,
}) => {
  const location = useLocation();

  return scheduleGuardManagement.map((item, index) => {
    const isActive = location?.pathname.includes(item?.path);

    return (
      <Link
        key={index}
        to={item.path}
        // onClick={() => handleSideNavClick(item.path)}
      >
        <div
          className={`${
            showSideNav && " "
          } flex gap-3 cursor-pointer mt-0.5 py-1.5 transition-colors duration-150 ease-in-out pl-4 ml-3 ${
            isActive ? activeSideNav : " hover:bg-[#00325d] hover:text-white"
          }`}
        >
          <span
            className={`transition-transform text-[14px] leading-[20px] ${
              showSideNav && activeIcons === "schedule"
                ? " bg-[#00325d] text-white "
                : ""
            } `}
            onClick={() => setActiveIcons("schedule")}
          >
            {item.icon}
          </span>
          <span className='text-[14px] leading-[20px] font-normal text-nowrap'>{item.title}</span>
        </div>
      </Link>
    );
  });
};
